import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaChevronDown, FaQuestionCircle, FaWater, FaClock, FaLeaf, FaWallet } from 'react-icons/fa';
import './FAQSection.css';

const faqs = [
    {
        question: "Avez-vous besoin d'un point d'eau ou d'électricité ?",
        answer: "Non, je suis totalement autonome. Mon véhicule est équipé d'un réservoir d'eau de grande capacité et de batteries professionnelles. Je peux donc intervenir partout, que ce soit sur un parking, dans votre jardin ou devant votre bureau.",
        icon: <FaWater />
    },
    {
        question: "Combien de temps dure une intervention ?",
        answer: "La durée dépend de la formule choisie : environ 1h30 pour une formule Standard, 2h30 pour une formule Premium, et jusqu'à 4h pour une formule Prestige complète. Le nettoyage de canapé prend généralement entre 1h et 2h selon la taille et l'état.",
        icon: <FaClock />
    },
    {
        question: "Les produits utilisés sont-ils sans danger ?",
        answer: "Oui, c'est une de nos priorités. Nous utilisons des produits éco-responsables à 97% biosourcés. Ils sont sans danger pour les enfants, les animaux domestiques et les matériaux les plus délicats de votre voiture (cuir, alcantara, écrans).",
        icon: <FaLeaf />
    },
    {
        question: "Comment puis-je régler ma prestation ?",
        answer: "Nous acceptons les paiements par carte bancaire (terminal mobile sécurisé), espèces ou virement immédiat. Une facture vous est systématiquement envoyée par email à la fin de l'intervention.",
        icon: <FaWallet />
    }
];

const FAQSection = () => {
    const [activeIndex, setActiveIndex] = useState(null);

    const toggleAccordion = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <section className="faq-section-premium">
            <div className="container">
                <motion.div
                    className="section-header text-center"
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8 }}
                >
                    <span className="section-label">Questions</span>
                    <h2 className="section-title">
                        Foire Aux <span className="text-gradient-blue">Questions</span>
                    </h2>
                    <p className="section-subtitle-text">
                        Tout ce que vous devez savoir sur nos interventions professionnelles à domicile.
                    </p>
                </motion.div>

                <div className="faq-grid-premium">
                    {faqs.map((faq, index) => (
                        <motion.div
                            key={index}
                            className={`faq-item-premium ${activeIndex === index ? 'active' : ''}`}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ delay: index * 0.1, duration: 0.5 }}
                        >
                            <button
                                className="faq-question-btn"
                                onClick={() => toggleAccordion(index)}
                                aria-expanded={activeIndex === index}
                            >
                                <span className="faq-question-content">
                                    <span className="faq-icon-wrapper">{faq.icon}</span>
                                    <span className="faq-question-text">{faq.question}</span>
                                </span>
                                <motion.span
                                    className="faq-chevron"
                                    animate={{ rotate: activeIndex === index ? 180 : 0 }}
                                >
                                    <FaChevronDown />
                                </motion.span>
                            </button>

                            <AnimatePresence>
                                {activeIndex === index && (
                                    <motion.div
                                        className="faq-answer-wrapper"
                                        initial={{ height: 0, opacity: 0 }}
                                        animate={{ height: 'auto', opacity: 1 }}
                                        exit={{ height: 0, opacity: 0 }}
                                        transition={{ duration: 0.4, ease: "easeInOut" }}
                                    >
                                        <div className="faq-answer-content">
                                            <p>{faq.answer}</p>
                                        </div>
                                    </motion.div>
                                )}
                            </AnimatePresence>
                        </motion.div>
                    ))}
                </div>

                <motion.div
                    className="faq-cta-footer text-center"
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    viewport={{ once: true }}
                    transition={{ delay: 0.5 }}
                >
                    <p>D'autres questions ?</p>
                    <a href="/contact" className="btn-contact-faq">
                        Contactez notre équipe
                    </a>
                </motion.div>
            </div>
        </section>
    );
};

export default FAQSection;
